import dayjs from "dayjs";

export const formatTableDateTime = (
  date: string | Date | null | undefined,
): string => (date ? dayjs(date).format("YYYY-MM-DD hh:mm:ss A") : "N/A");
